namespace Gamification.Gamification {
    export namespace UtentiParametriGlobaliService {
        export const baseUrl = 'Gamification/UtentiParametriGlobali';

        export declare function Create(request: Serenity.SaveRequest<UtentiParametriGlobaliRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UtentiParametriGlobaliRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UtentiParametriGlobaliRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UtentiParametriGlobaliRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/UtentiParametriGlobali/Create",
            Update = "Gamification/UtentiParametriGlobali/Update",
            Delete = "Gamification/UtentiParametriGlobali/Delete",
            Retrieve = "Gamification/UtentiParametriGlobali/Retrieve",
            List = "Gamification/UtentiParametriGlobali/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UtentiParametriGlobaliService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
